module.exports = __webpack_public_path__ + "img/216.ed3d0621.jpg";